import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {ScoresDisplayEvent} from "../models/events/scores-display-event";
import {ACTION_TYPES} from "../consts";

export class ScoresDisplayEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.scoresDisplayHandler;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = ScoresDisplayEvent;
  }
}
